import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import StatsSection from './components/StatsSection';
import NewsletterSection from './components/NewsletterSection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '援助交配现象研究中心',
  url: 'https://jiahe01.cn',
  description: '围绕援助交配现象展开深度研究，系统梳理其定义、社会背景、心理动因与现实影响，提供客观、理性的分析视角与参考资料。',
  inLanguage: 'zh-CN',
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '援助交配现象研究中心',
  url: 'https://jiahe01.cn',
  description: '致力于以客观、理性的学术视角，深度研究援助交配现象的社会成因、心理机制与多维影响。',
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }} />

      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedArticles />
        <StatsSection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}